export default "/fonts/Urbanist-Thin.ttf?acea80455c0de9c461741d20fa9e7c7a";